import { useT } from "@/lib/i18n";
import { MONTH_NAMES } from "@/lib/resumeUtils";

export default function YmPicker({ value, onChange, disabled, testId }) {
  const { lang } = useT();
  const m = /^(\d{4})-(\d{2})$/.exec(value || "");
  const year = m ? m[1] : "";
  const month = m ? m[2] : "";
  const names = MONTH_NAMES[lang] || MONTH_NAMES.nl;

  const emit = (y, mo) => {
    if (y && mo) onChange(`${y}-${mo}`);
    else onChange("");
  };

  return (
    <div className="grid grid-cols-[1fr_6.5rem] gap-2">
      <select
        data-testid={`${testId}-month`}
        className="ed-input"
        value={month}
        disabled={disabled}
        onChange={(e) => {
          const mo = e.target.value;
          emit(mo ? (year || String(new Date().getFullYear())) : year, mo);
        }}
      >
        <option value="">—</option>
        {names.map((name, i) => (
          <option key={name} value={String(i + 1).padStart(2, "0")}>{name}</option>
        ))}
      </select>
      <input
        data-testid={`${testId}-year`}
        type="number"
        min="1950"
        max="2100"
        placeholder="2024"
        className="ed-input w-24"
        value={year}
        disabled={disabled}
        onChange={(e) => emit(e.target.value.slice(0, 4), month)}
      />
    </div>
  );
}
